
export const TypeClasses = {
    date: {
        clazz: 'date-picker',
        format: 'DD/MM/YYYY',
        options: { pickTime: false },
    },
    datetime: {
        clazz: 'datetime-picker',
        format: 'DD/MM/YYYY HH:mm',
        options: {},
    },
} as const;

export type PickerType = keyof typeof TypeClasses;
export type ValueFormat = 'local' | 'xml';
export const NullTime = new Date(0);

export type PickerAppearance = 'simple' | 'button-start' | 'button-end';
